import '../styles/Loading.css'

function Loading() {
  return (
    <div className="lds-heart"><div></div></div>
  );
}

export default Loading;
